import { isNumber } from 'lodash';

import { type AtlasGqlTask, AtlasGqlWorkContainerTypeOption } from 'types/atlas-graphql';

export const isParentWorkOrderSubscribed = (workContainer: Partial<AtlasGqlTask>): boolean => {
  const workOrder = workContainer.parent;

  return !!workOrder?.subscribedToNotifications;
};

export const isParentCampaignSubscribed = (workContainer: Partial<AtlasGqlTask>): boolean => {
  const campaign =
    workContainer.type?.type === AtlasGqlWorkContainerTypeOption.WorkOrder
      ? workContainer.parent // get work order's campaign
      : workContainer.parent?.parent; // get task's campaign

  return !!campaign?.subscribedToNotifications;
};

export const getParentWorkOrderLink = (
  workContainer: Partial<AtlasGqlTask>,
  includeNumber: boolean = false
): JSX.Element => {
  const workOrder = workContainer.parent;

  return (
    <a href={`/work-orders/${workOrder?.id}`} target="_blank" rel="noreferrer">
      Work Order{includeNumber && isNumber(workOrder?.number) ? ` #${workOrder?.number}` : ''}
    </a>
  );
};

export const getParentCampaignLink = (
  workContainer: Partial<AtlasGqlTask>,
  includeNumber: boolean = true
): JSX.Element => {
  const campaign =
    workContainer.type?.type === AtlasGqlWorkContainerTypeOption.WorkOrder
      ? workContainer.parent // get work order's campaign
      : workContainer.parent?.parent; // get task's campaign

  return (
    <a href={`/campaigns/${campaign?.id}`} target="_blank" rel="noreferrer">
      Campaign{includeNumber && isNumber(campaign?.number) ? ` #${campaign?.number}` : ''}
    </a>
  );
};
